package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.domain.model.ContentType
import com.iptvplayer.shared.presentation.viewmodel.HomeViewModel
import com.iptvplayer.web.ui.*

@Composable
fun HomeScreen(vm: HomeViewModel, onPlay: OnPlay, onSeriesOpen: OnSeriesOpen, onOpenSources: () -> Unit = {}) {
    val state by vm.state.collectAsState()

    PageContainer {
        val empty = state.channels.isEmpty() && state.vodItems.isEmpty() && state.series.isEmpty() && state.continueWatching.isEmpty()
        if (state.isLoading && empty) {
            Spinner("Syncing content from your provider…")
            return@PageContainer
        }
        // Explain *why* content is missing (source down / no sources / …)
        // instead of a bare empty page.
        state.issue?.let { issue ->
            IssueBanner(issue, onRetry = { vm.refresh() }, onOpenSources = onOpenSources)
        }
        if (empty) {
            EmptyState(
                if (state.issue != null) "Nothing to show — see the message above."
                else "No content yet. Add an IPTV source in Settings → Sources."
            )
            return@PageContainer
        }

        if (state.continueWatching.isNotEmpty()) {
            SectionTitle("Continue watching")
            MediaGrid {
                state.continueWatching.forEach { h ->
                    MediaCard(h.contentName, h.contentLogoUrl, null) {
                        onPlay(h.contentId, h.contentName, h.streamUrl, h.contentType, h.contentLogoUrl)
                    }
                }
            }
        }
        if (state.channels.isNotEmpty()) {
            SectionTitle("Live channels")
            MediaGrid {
                state.channels.take(30).forEach { c ->
                    MediaCard(c.name, c.logoUrl, c.group) {
                        onPlay(c.id, c.name, c.streamUrl, ContentType.CHANNEL, c.logoUrl)
                    }
                }
            }
        }
        if (state.vodItems.isNotEmpty()) {
            SectionTitle("Movies")
            MediaGrid {
                state.vodItems.take(30).forEach { v ->
                    MediaCard(v.name, v.coverUrl, v.genre) {
                        onPlay(v.id, v.name, v.streamUrl, ContentType.VOD, v.coverUrl)
                    }
                }
            }
        }
        if (state.series.isNotEmpty()) {
            SectionTitle("Series & shows")
            MediaGrid {
                state.series.take(30).forEach { s ->
                    MediaCard(s.name, s.posterUrl, s.genre) {
                        onSeriesOpen(s.sourceId, s.seriesId, s.name)
                    }
                }
            }
        }
    }
}
